import realtimeTables from '../../../shared/constants/realtimeTables';
import ProviderDTO from '../../../shared/dtos/providerDTO';
import { getRealTimeDB } from './client';
import { ref, onValue, off, DatabaseReference } from 'firebase/database';
import dayjs from "dayjs";
import UserRequestDTO from '../../../shared/dtos/userRequestDTO';
import { TRIP_STATUS } from '../../../shared/constants/TripStatus';

const database = getRealTimeDB();

export const subscribeTripTracking = (bookingID: string, actionCallBack: (val: any) => void): DatabaseReference => {
  const tripsTrackingRef = ref(database, `${realtimeTables.TRIPS_TRACKING}/${bookingID}`);
  onValue(tripsTrackingRef, (snapshot) => {
    const tripTrack = snapshot.val();

    if (!tripTrack?.coords) return;

    const coords = Object.keys(tripTrack.coords);
    const lastPosition = tripTrack.coords[coords[coords.length - 1]];
    actionCallBack({ latitude: lastPosition.latitude, longitude: lastPosition.longitude });
  });

  return tripsTrackingRef;
};

export const subscribeDriverTracking = (setActiveProviders: React.Dispatch<React.SetStateAction<ProviderDTO[]>>): DatabaseReference => {
  const tripsTrackingRef = ref(database, `${realtimeTables.APP_DRIVER_LOCATION}`);
  onValue(tripsTrackingRef, (snapshot) => {
    const drivers: ProviderDTO[] = [];
    const timeLimit = dayjs().subtract(2, 'hour');
    snapshot.forEach(child => {
      const driver = child.val();
      const driverTimestamp = dayjs(driver.timestamp);
      if (driverTimestamp > timeLimit)
        drivers.push(child.val());
    });
    setActiveProviders(drivers);
  });

  return tripsTrackingRef;
};

export const subscribeTripRecords = (
  setActiveTrips: (val: UserRequestDTO[]) => void
) => {
  const tripRecordsRef = ref(database, `${realtimeTables.TRIP_RECORDS}`);

  onValue(tripRecordsRef, (snapshot) => {
    const data = snapshot.val() as Record<string, UserRequestDTO> | null;
    if (!data) {
      setActiveTrips([]);
      return;
    }
    const currentUserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const tripsArray: UserRequestDTO[] = Object.entries(data).map(([id, value]) => {
      const { scheduleAt, ...trip } = value as UserRequestDTO;
      const formattedScheduleAt = dayjs(scheduleAt).tz(currentUserTimeZone).format("YYYY-MM-DD HH:mm");
      return {
        bookingId: String(id),
        scheduleAt: formattedScheduleAt,
        ...trip,
      }
    });

    const statusOrder = [
      TRIP_STATUS.Searching,
      TRIP_STATUS.Started,
      TRIP_STATUS.Accepted,
      TRIP_STATUS.Arrived,
      TRIP_STATUS.PickedUp,
      TRIP_STATUS.Dropped,
      TRIP_STATUS.Scheduled
    ];

    const activeTrips = tripsArray
      .filter(trip => statusOrder.includes(trip.status!))
      .sort((a, b) => {
        const statusDiff =
          statusOrder.indexOf(a.status!) - statusOrder.indexOf(b.status!);

        if (statusDiff !== 0) {
          return statusDiff;
        }

        return dayjs(a.scheduleAt).valueOf() - dayjs(b.scheduleAt).valueOf();
      });

    setActiveTrips(activeTrips);
  });

  return () => off(tripRecordsRef);
};

export const unSubscribe = (dbRef: DatabaseReference) => {
  off(dbRef);
};
